var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    fill: "none",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    fill: "#85A4E6",
    points: "0.8,5.9 3.7,0.8 9.5,0.8 12.4,5.9 9.5,10.9 3.7,10.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    fill: "#5C85DE",
    points: "11.4,7.7 8.5,2.6 9.5,0.7 12.4,5.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape-Copy_00000019646383529055310330000009913415011964925323_",
    fillRule: "evenodd",
    fill: "#3367D6",
    points: " 2.7,9.3 8.5,9.3 10.5,5.9 11.4,7.7 9.5,10.9 3.7,11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    fill: "#85A4E6",
    points: "11.2,11.9 14.2,6.8 20,6.8 22.9,11.9 20,16.9 14.2,16.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape-Copy_00000133527958483064390410000012377415375428947900_",
    fillRule: "evenodd",
    fill: "#5C85DE",
    points: " 21.9,13.7 19,8.6 20,6.7 22.9,11.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape-Copy_00000176019471624316745960000001248137580190207128_",
    fillRule: "evenodd",
    fill: "#3367D6",
    points: " 13.2,15.3 19,15.3 21,11.9 21.9,13.7 20,16.9 14.2,17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    fill: "#85A4E6",
    points: "0.8,17.9 3.7,12.8 9.5,12.8 12.4,17.9 9.5,22.9 3.7,22.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape-Copy_00000096041779745201399360000017167964797373102485_",
    fillRule: "evenodd",
    fill: "#5C85DE",
    points: " 11.4,19.7 8.5,14.6 9.5,12.7 12.4,17.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape-Copy_00000049204188488742950820000010444321201512143025_",
    fillRule: "evenodd",
    fill: "#3367D6",
    points: " 2.7,21.3 8.5,21.3 10.5,17.9 11.4,19.7 9.5,22.9 3.7,23  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.c4208f276ddf5824a3a95436a7d97b45.svg";
export { ForwardRef as ReactComponent };